import React, { useState } from 'react';
import { TruncateWalletAddress } from '../../functions/TruncateWalletAddress';
import styles from '../../styles/common/WalletAddress.module.scss';

interface WalletAddressProps {
  address: string;
  showCopyButton?: boolean;
  truncateLength?: {
    start?: number;
    end?: number;
  };
  className?: string;
}

const WalletAddress: React.FC<WalletAddressProps> = ({
  address,
  showCopyButton = true,
  truncateLength,
  className
}) => {
  const [copied, setCopied] = useState(false);

  const truncatedAddress = TruncateWalletAddress({
    address,
    startLength: truncateLength?.start,
    endLength: truncateLength?.end
  });

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(address);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy address:', err);
    }
  };

  return (
    <div className={`${styles.walletAddress} ${className || ''}`}>
      <span 
        className={styles.address}
        title={address}
      >
        {truncatedAddress}
      </span>
      {showCopyButton && (
        <button
          className={`${styles.copyButton} ${copied ? styles.copied : ''}`}
          onClick={handleCopy}
          title={copied ? 'Copied!' : 'Copy address'}
        >
          {copied ? (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path 
                d="M20 6L9 17l-5-5" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <rect 
                x="9" 
                y="9" 
                width="13" 
                height="13" 
                rx="2" 
                ry="2" 
                stroke="currentColor" 
                strokeWidth="2"
              />
              <path 
                d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" 
                stroke="currentColor" 
                strokeWidth="2"
              />
            </svg>
          )}
        </button>
      )}
    </div>
  );
};

export default WalletAddress;
